import ContentCard from "../../../Components/ContentCard";
import PDFMetadataEditor from "../../../Components/PDFMetadataEditor";
import { Helmet } from "react-helmet-async";

const Metadata = () => {
    return (
        <>
            <Helmet>
                <title>PDF Metadaten bearbeiten – kostenlos online | FileForge</title>
                <meta name="description" content="Bearbeiten Sie Titel, Autor und weitere Metadaten Ihrer PDF-Dateien – kostenlos, ohne Anmeldung, direkt im Browser." />
                <link rel="canonical" href="https://www.file-forge.org/pdf-metadaten-bearbeiten" />
            </Helmet>

            <ContentCard
                title="Metadaten bearbeiten"
                description="Bearbeiten Sie die Metadaten Ihrer PDF-Dateien."
                baseClases="p-6 m-2 border flex flex-col gap-4 w-full"
            >
                <PDFMetadataEditor />
            </ContentCard>
        </>
    )
}

export default Metadata